<template>
    <div class="tap-screen-container">
        <div class="overlay" v-show="visible || androidVisible" @click="androidVisible = false"></div>
        <input type="number" autocomplete="off" id="tapInput" v-model="comandaNumber">

        <div class="page-title-tap">
            <span>{{ getString('identificacao_de') }}{{ getString('comanda_maiusculo') }}</span>
        </div>

        <div class="screen-limits">
            <div class="container-barCode" :class="{ 'useBarcodeComand': useBarcodeComand }">
                <div class="upper-text">
                    <div class="bar-code-info">
                        <img :src="tapScreenImg" class="bar-code-img">
                        <div class="bar-code-text">
                            <span>{{ getString('posicione_o_codigo') }}</span>
                            <span>{{ getString('de_barras_comanda') }}</span>
                            <span>{{ getString('no_leitor_abaixo') }}</span>
                        </div>
                    </div>
                    <span v-if=!useBarcodeComand class="bar-code-text-2">{{ getString('ou_digite_numero_comanda')
                    }}</span>
                </div>
                <div class="comanda-input-container-tap-screen" :class="{ 'useBarcodeComand': useBarcodeComand }">
                    <div id="comandaNumber" class="div-input-android" :class="{ 'error': errorMessage }"
                        ref="comandaNumberDiv">
                    </div>
                    <span class="error">{{ errorMessage }}</span>
                </div>

                <AndroidKeyboard v-if=!useBarcodeComand id="android-keyboard" :inputElement="inputElement"
                    :layout="layout" :bigNumeric="true">
                </AndroidKeyboard>
            </div>

            <!-- <img :src="getImage() || tapscreen"> -->
            <div class="button-container-tap-screen" :class="{ 'useBarcodeComand': useBarcodeComand }">
                <!-- <DefaultButton class="button" :text="getString('digitar_com_teclado')" @defaultBtnClick="showKeyBoard"></DefaultButton> -->
                <DefaultButton class="cancel-button"
                    :text="!controlsEnabled ? getString('aguarde') : getString('confirmar')"
                    :disabled="!controlsEnabled ? true : false" :green="!controlsEnabled ? false : true"
                    @defaultBtnClick="acceptAndroid"></DefaultButton>
                <DefaultButton class="cancel-button" :text="getString('cancelar')" :outlined="true"
                    @defaultBtnClick="navigateBack"></DefaultButton>
            </div>
        </div>
        <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide"
            :next="accept" :accept="accept" :input="input" />
    </div>
</template>

<script>
import Vue from 'vue'
import ProductController from '@/assets/controllers/ProductController'
import CartController from '@/assets/controllers/CartController'
import RfidController from '@/assets/controllers/RfidController'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import VueTouchKeyboard from 'vue-touch-keyboard'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
import keyboardLayout from '@/assets/libs/keyboardLayout'

Vue.use(VueTouchKeyboard)

export default {
    name: 'TAPScreen',
    components: {
        CartController,
        Util,
        DefaultButton,
        'vue-touch-keyboard': VueTouchKeyboard.component,
        AndroidKeyboard
    },
    data () {
        return {
            visible: false,
            comandaNumber: '',
            filteredComandaNumber: '',
            androidBarCodeComanda: '',
            androidVisible: false,
            useBarcodeComand: Util.getLocalConfigs('useBarcodeComand'),
            // layout: null,
            // tapscreen: require('../../static/icons/tapscreen.jpg'),
            inputElement: null,
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            tapScreenImg: require('../../static/icons/ic-codigo-barras.png'),
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            controlsEnabled: true,
            barcodeInterval: null,
            gertecBarcodeInterval: null,
            errorMessage: '',
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false
        }
    },
    created () {
        eventModule.$on('restartListenForRfid', this.restartListenForRfid)
    },
    mounted () {
        this.inputElement = this.$refs.comandaNumberDiv
        if (this.inputElement) {
            this.inputElement.innerText = ''
        }
        this.comandaNumber = ''
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            setTimeout(() => {
                window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
            }, 1000)

            this.gertecBarcodeInterval = setInterval(() => {
                let readedCode = window.GertecBarcodeReader.getReadedCode()
                if (readedCode) {
                    this.comandaNumber = readedCode
                    this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
                    if (this.filteredComandaNumber && this.filteredComandaNumber.length > 0) {
                        this.inputElement.innerText = this.filteredComandaNumber
                        this.accept()
                    }
                    this.comandaNumber = ''
                }
            }, 1000)
        } else if (Util.isAndroidMode()) {
            document.addEventListener('keypress', this.handleAndroidKeypress)
        } else {
            document.getElementById('tapInput').addEventListener('keypress', this.handleKeypress)
            this.barcodeInterval = setInterval(() => {
                if (document.getElementById('tapInput')) {
                    document.getElementById('tapInput').focus()
                }
            }, 500)
        }

        CartController.resetCart()
        RfidController.listenForRfid(this.handleCardSerialNumber)
    },
    beforeDestroy () {
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            clearInterval(this.gertecBarcodeInterval)
            window.GertecBarcodeReader.stopDecode()
        } else if (Util.isAndroidMode()) {
            document.removeEventListener('keypress', this.handleAndroidKeypress)
        } else {
            clearInterval(this.barcodeInterval)
            let tapInput = document.getElementById('tapInput')
            if (tapInput) {
                tapInput.removeEventListener('keypress', this.handleKeypress)
            }
        }

        RfidController.stopListeningForRfid()
        eventModule.$off('restartListenForRfid', this.restartListenForRfid)
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        enableControls: function () {
            this.controlsEnabled = true
        },
        disableControls: function () {
            this.controlsEnabled = false
        },
        handleAndroidKeypress: async function (event) {
            if (event.key === 'Enter' && this.controlsEnabled) {
                this.comandaNumber = this.androidBarCodeComanda
                this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
                this.androidBarCodeComanda = ''
                this.inputElement.innerText = this.filteredComandaNumber
                await this.accept()
                this.comandaNumber = ''
            } else if (this.controlsEnabled) {
                this.androidBarCodeComanda += event.key
            }
        },
        restartListenForRfid: function () {
            RfidController.listenForRfid(this.handleCardSerialNumber)
        },
        handleCardSerialNumber: function (cardSerialNumber) {
            this.inputElement = this.$refs.comandaNumberDiv
            try {
                this.inputElement.innerText = cardSerialNumber
            } catch (error) {
                console.log('Não foi possível atualizar o input no modo Android - TAP Screen')
            }
            this.comandaNumber = cardSerialNumber
            this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
            this.accept()
        },
        showKeyBoard: function () {
            if (Util.isAndroidMode()) {
                this.androidVisible = true
                this.layout = keyboardLayout.SIMPLE_NUMERIC
                this.inputElement = this.$refs.comandaNumberDiv
            } else {
                let inElement = document.getElementById('comandaNumber')
                this.input = inElement
                this.layout = inElement.dataset.layout

                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        acceptAndroid: async function () {
            this.androidVisible = false
            try {
                this.comandaNumber = this.$refs.comandaNumberDiv.innerText
                this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
                if (this.controlsEnabled && this.filteredComandaNumber.length > 0) {
                    this.comandaNumber = ''
                    await this.accept()
                } else if (this.filteredComandaNumber.length === 0) {
                    this.comandaNumber = ''
                    this.setMessageError('Informe a comanda!')
                }
            } catch (error) {
                this.comandaNumber = ''
            }
        },
        accept: async function () {
            if (this.controlsEnabled) {
                this.disableControls()
                this.stopEventsListners()
                RfidController.stopListeningForRfid()
                let error = await ProductController.getProductsFromComanda(this.filteredComandaNumber)
                this.hide()
                if (!error.error) {
                    // Comanda já existe e tem produtos — segue direto pro checkout
                    this.$router.push('checkout')
                    this.comandaNumber = ''
                } else {
                    if (this.isAndroidMode()) this.clearAndroidInput()
                    if (error && error.code === 'ERR_GET_ORDER_DATA') {
                        if (Util.autoOpenCommand()) {
                            // Comanda não existe — abre modal de criação no Checkout
                            let pendingComandaNumber = Util.deepCopy(this.filteredComandaNumber)
                            Util.showConfirmationDialog(this.$modal, () => {
                                this.$router.push({
                                    name: 'Checkout',
                                    params: {
                                        pendingComandaNumber: pendingComandaNumber,
                                        openAddProductModal: true
                                    }
                                })
                            }, this.getString('comanda_nao_encontrada_abrir_nova'), () => {})
                        } else {
                            await this.setMessageError(this.getString('comanda_nao_encontrada'))
                        }
                    }
                    this.clearInputsAndResetListeners()
                }
            }
        },
        clearInputsAndResetListeners: function () {
            if (this.isAndroidMode()) this.clearAndroidInput()
            this.filteredComandaNumber = ''
            this.comandaNumber = ''
            this.inputElement.innerText = ''
            this.enableControls()
            this.startEventsListners()
        },
        hide: function () {
            this.visible = false
        },
        clearAndroidInput: function () {
            try {
                this.$refs.comandaNumberDiv.innerText = ''
            } catch (error) {
                console.log('Não foi possível limpar a div de input no modo Android - TAP Screen')
            }
        },
        handleKeypress: async function (event) {
            if (event.key === 'Enter' && this.controlsEnabled) {
                this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
                this.comandaNumber = ''
                if (this.filteredComandaNumber && this.filteredComandaNumber.length > 0) {
                    this.inputElement.innerText = this.filteredComandaNumber
                    await this.accept()
                }
            } else if (event.key === 'Enter' && !this.controlsEnabled) {
                this.comandaNumber = ''
            }
        },
        getImage: function () {
            return Util.getConfigImage('tapscreen')
        },
        navigateBack: function () {
            this.$router.push('/')
        },
        setMessageError: async function (message) {
            this.errorMessage = message
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    // this.errorMessage = ''
                    resolve()
                }, 1500)
            })
        },
        stopEventsListners: function () {
            if (Util.isAndroidMode() && Util.isGertecSk210()) {
                clearInterval(this.gertecBarcodeInterval)
                window.GertecBarcodeReader.stopDecode()
            } else if (Util.isAndroidMode()) {
                document.removeEventListener('keypress', this.handleAndroidKeypress)
            } else {
                clearInterval(this.barcodeInterval)
                let tapInput = document.getElementById('tapInput')
                if (tapInput) {
                    tapInput.removeEventListener('keypress', this.handleKeypress)
                }
            }

            RfidController.stopListeningForRfid()
            eventModule.$off('restartListenForRfid', this.restartListenForRfid)
        },
        startEventsListners: function () {
            this.inputElement = this.$refs.comandaNumberDiv

            if (Util.isAndroidMode() && Util.isGertecSk210()) {
                setTimeout(() => {
                    window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
                }, 1000)

                this.gertecBarcodeInterval = setInterval(() => {
                    let readedCode = window.GertecBarcodeReader.getReadedCode()
                    if (readedCode) {
                        this.comandaNumber = readedCode
                        this.filteredComandaNumber = Util.deepCopy(this.comandaNumber).toString().trim()
                        if (this.filteredComandaNumber && this.filteredComandaNumber.length > 0) {
                            this.inputElement.innerText = this.filteredComandaNumber
                            this.accept()
                        }
                        this.comandaNumber = ''
                    }
                }, 1000)
            } else if (Util.isAndroidMode()) {
                document.addEventListener('keypress', this.handleAndroidKeypress)
            } else {
                document.getElementById('tapInput').addEventListener('keypress', this.handleKeypress)
                this.barcodeInterval = setInterval(() => {
                    if (document.getElementById('tapInput')) {
                        document.getElementById('tapInput').focus()
                    }
                }, 500)
            }
            RfidController.listenForRfid(this.handleCardSerialNumber)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.tap-screen-container {
    width: 100vw;
    height: 100vh;
    background-color: white;

    .overlay {
        z-index: 0;
        .full;
        content: '';
        background: black;
        opacity: .5;
    }

    #tapInput {
        position: absolute;
        opacity: 0;
    }

    .page-title-tap {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: @primary-color;
        padding: 3vh 0 3vh 0;
        color: white;

        span {
            font-size: 4.8rem;
        }
    }

    .screen-limits {
        margin: 70px 120px 0 120px;
        display: flex;
        flex-direction: column;
        height: 75%;

        .container-barCode {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-evenly;
            &.useBarcodeComand {
                justify-content: center;
            }

            .upper-text {
                display: flex;
                flex-direction: column;
                align-items: center;

                .bar-code-info {
                    display: flex;

                    .bar-code-img {
                        width: 250px;
                        height: 178px;
                        margin-right: 30px;
                    }

                    .bar-code-text {
                        display: flex;
                        flex-direction: column;
                        font-size: 50px;
                        font-weight: bold;
                    }
                }

                .bar-code-text-2 {
                    margin-top: 50px;
                    font-size: 55px;
                }
            }

            .comanda-input-container-tap-screen {
                // position: fixed;
                // left: 0;
                // right: 0;
                // top: calc(100vh - 60%);
                // background: @primary-color;
                // padding: 50px 0;
                // color: white;
                margin: 40px 0;
                &.useBarcodeComand {
                    margin: 100px 0;
                }
                #comandaNumber {
                    &.div-input-android {
                        position: relative;
                        margin: auto;
                        display: block;
                        font-size: 5rem;
                        height: 110px;
                        background-color: white;
                        color: black;
                        border: 2px solid black;
                        border-radius: 20px;
                        padding: 0 20px;

                        &.error {
                            border: 2px solid rgb(185, 20, 20);
                            color: rgb(185, 20, 20);
                        }
                    }
                }

                span.error {
                    display: flex;
                    justify-content: center;
                    font-size: 30px;
                    padding-top: 15px;
                    color: rgb(185, 20, 20);
                }
            }
        }

        .button-container-tap-screen {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            flex-grow: 1;
            margin: 0;

            .cancel-button,
            .button {
                margin: 10px auto;
                width: 100%;
            }
        }
    }

    #keyboard {
        .keyboard;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .tap-screen-container {
        .page-title-tap {
            height: 50;

            span {
                font-size: 3rem;
            }
        }

        .screen-limits {
            // margin: 0px 90px 0 90px;

            .container-barCode {
                .upper-text {
                    .bar-code-info {
                        .bar-code-img {
                            width: 200px;
                            height: 150px;
                        }

                        .bar-code-text {
                            font-size: 2rem;
                        }
                    }

                    .bar-code-text-2 {
                        font-size: 2.1rem;
                    }
                }

                .comanda-input-container-tap-screen {
                    margin: 15px;
                    padding: 20px 0 10px 0;
                    &.useBarcodeComand {
                        margin: 50px 0;
                    }
                    #comandaNumber {
                        &.div-input-android {
                            height: 80px;
                            font-size: 4rem;
                        }
                    }
                }
            }

            .button-container-tap-screen {
                bottom: 40px;
            }
        }

        #keyboard {
            .keyboard;
            max-width: 760px;
            font-size: 20px;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .tap-screen-container {
        .page-title-tap {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            padding-top: 0;
            padding-bottom: 0;
            margin-bottom: 25px;

            span {
                font-size: 30px;
            }
        }

        .screen-limits {
            margin: 15px 40px 0 40px;
            height: 83%;

            .container-barCode {
                .upper-text {
                    .bar-code-info {
                        .bar-code-img {
                            width: 100px;
                            height: 80px;
                            margin-right: 10px;
                        }

                        .bar-code-text {
                            font-size: 25px;
                        }
                    }

                    .bar-code-text-2 {
                        margin-top: 10px;
                        font-size: 25px;
                    }
                }

                .comanda-input-container-tap-screen {
                    margin: 20px 0;
                    &.useBarcodeComand {
                        margin: 20px 0;
                    }
                    #comandaNumber {
                        &.div-input-android {
                            height: 35px;
                            font-size: 30px;
                            padding: 0 15px;
                            border-radius: 5px;
                        }
                    }
                }
            }

            .button-container-tap-screen {
                .cancel-button {
                    margin: 0 auto 10px auto;
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .tap-screen-container {
        width: 100vw;
        height: calc(100vh - 30px);
        background-color: white;

        .page-title-tap {
            height: 50px;

            span {
                font-size: 2.3rem;
            }
        }

        .screen-limits {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 70%;
            .container-barCode {
                .upper-text {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 0 20px;

                    .bar-code-info {
                        display: flex;

                        .bar-code-img {
                            width: 170px;
                            height: 90px;
                            margin-right: 30px;
                        }

                        .bar-code-text {
                            display: flex;
                            flex-direction: column;
                            font-size: 25px;
                            font-weight: bold;
                        }
                    }

                    .bar-code-text-2 {
                        margin: 10px 0;
                        font-size: 25px;
                        grid-area: left-top;
                    }
                }

                .comanda-input-container-tap-screen {
                    margin: 0 15px;
                    padding: 0 0 10px 0;
                    grid-area: right-top;

                    #comandaNumber {
                        &.div-input-android {
                            height: 50px;
                            width: auto;
                            font-size: 2.6rem;
                            margin: 0;
                            overflow-x: auto;

                            &.error {
                                border: 2px solid rgb(185, 20, 20);
                                color: rgb(185, 20, 20);
                            }
                        }
                    }

                    span.error {
                        display: flex;
                        justify-content: center;
                        font-size: 20px;
                        padding-top: 10px;
                        color: rgb(185, 20, 20);
                    }
                }
            }

            .button-container-tap-screen {
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 60%;
                .cancel-button,
                .button {
                    margin: 10px;
                }
            }
        }
        #android-keyboard {
            margin: 0 0 !important;
        }
    }
}
</style>

<style lang='less'>
.tap-screen-container {
    .cancel-button {
        span {
            font-size: 45px;
        }
    }
}

@media (orientation: landscape) {
    .tap-screen-container {
        .cancel-button {
            span {
                font-size: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/TAPScreen.vue